import moment from "moment";

export const MIN_EMPLOYEE_AGE = 16;
export const DOB_DISPLAY_FORMAT = "MM/DD/YYYY";

export function getMaxDobDate() {
  return moment().subtract(MIN_EMPLOYEE_AGE, "years");
}

/**
 * Returns true when dob parses to a person at least MIN_EMPLOYEE_AGE years old.
 * Accepts common app formats (MM/DD/YYYY, YYYY-MM-DD) or a Date/moment value.
 */
export function isEmployeeAgeValid(dob, format = DOB_DISPLAY_FORMAT) {
  if (!dob) {
    return false;
  }

  let parsed = moment(dob, format, true);
  if (!parsed.isValid()) {
    parsed = moment(dob);
  }
  if (!parsed.isValid()) {
    return false;
  }

  return moment().diff(parsed, "years") >= MIN_EMPLOYEE_AGE;
}

export function getEmployeeDobErrorMessage() {
  return `Invalid DOB date is provided. Age should be at least ${MIN_EMPLOYEE_AGE} years.`;
}
